import { ArrowUp } from 'iconsax-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { DarkModeSwitch } from '@/components/DarkModeSwitch/DarkModeSwitch'
import { WeScreen } from '@/components/WeScreen/WeScreen'
import { AppRoutes } from '@/constants/appRoutes'
import { useLogout } from '@/hooks/useLogout'
import {
  EUserPermission,
  EUserRole,
} from '@/hooks/usePermissions/permissions.type'
import { usePermissions } from '@/hooks/usePermissions/usePermissions'
import { weCheckPalette } from '@/utils/palette/weCheckPalette'

interface NavItem {
  label: string
  to: AppRoutes
  visible: boolean
}

export const SettingsList = () => {
  const { t } = useTranslation()
  const { hasPermission } = usePermissions()
  const { logout } = useLogout()

  const navItems: NavItem[] = [
    {
      label: t('dashboard.account.account'),
      to: AppRoutes.settingsAccount,
      visible: true,
    },
    {
      label: t('security.title'),
      to: AppRoutes.settingsSecurity,
      visible: true,
    },
    {
      label: t('dashboard.account.company'),
      to: AppRoutes.settingsCompany,
      visible: hasPermission(
        EUserPermission.HANDLE_ENTERPRISES,
        EUserRole.WORKSPACE_ADMIN,
      ),
    },
    {
      label: t('dashboard.account.reportSettingsTitle'),
      to: AppRoutes.settingsReports,
      visible: hasPermission(
        EUserPermission.HANDLE_REPORTS,
        EUserRole.TEAM_ANALYST,
      ),
    },
    {
      label: t('dashboard.account.apiKey'),
      to: AppRoutes.settingsApiKeys,
      visible: true,
    },
  ]

  return (
    <WeScreen
      useHeader={false}
      useNextButton={false}
      useSkipButton={false}
      contentClassName="p-0 max-md:p-0"
    >
      <div className="flex flex-col">
        {navItems
          .filter((item) => item.visible)
          .map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="flex items-center justify-between border-b border-neutralColor5 p-5 transition-colors hover:bg-baseColorHighlight"
            >
              <span className="text-xl font-medium text-neutralColor">
                {item.label}
              </span>
              <ArrowUp
                size={16}
                color={weCheckPalette.neutralColor60}
                className="rotate-45"
              />
            </Link>
          ))}

        <div className="flex min-h-[64px] items-center justify-between border-b border-neutralColor5 p-5">
          <span className="text-xl font-medium text-neutralColor">
            {t('dashboard.account.theme')}
          </span>
          <DarkModeSwitch />
        </div>

        <button
          type="button"
          onClick={logout}
          className="flex items-center justify-between p-5 text-left transition-colors hover:bg-baseColorHighlight"
        >
          <span className="text-xl font-medium text-dynamicRed">
            {t('dashboard.sidebar.signOut')}
          </span>
        </button>
      </div>
    </WeScreen>
  )
}
